import { APP_ENVIRONMENT, ENVIRONMENTS } from "shared/utils/platform";

const COMPANY_OVERVIEW_DASHBOARD_RESOURCES = {
    [ENVIRONMENTS.production]: "analytics-overview",
    [ENVIRONMENTS.demo]: "company-overview-demo",
    [ENVIRONMENTS.test]: "company-overview-testing",
    [ENVIRONMENTS.development]: "company-overview-testing",
};

// Company overview dashboard
export const getCompanyOverviewDashboardResource = (): string => {
    const appEnvironment = APP_ENVIRONMENT;

    const availableEnvironments = Object.keys(COMPANY_OVERVIEW_DASHBOARD_RESOURCES);

    if (!availableEnvironments.includes(appEnvironment)) {
        console.warn(`Environment ${appEnvironment} is not supported. Defaulting to development environment.`);

        return COMPANY_OVERVIEW_DASHBOARD_RESOURCES[ENVIRONMENTS.development];
    }

    return COMPANY_OVERVIEW_DASHBOARD_RESOURCES[appEnvironment];
};